export default __webpack_public_path__ + "static/img/login-background.9cd1566.png";